import React, { useEffect } from "react";
import {
  Box,
  Container,
  Grid,
  Divider,
  useMediaQuery,
  useTheme,
  makeStyles
} from "@material-ui/core";
import TitleText from "../../components/reusableComponents/TitleText";
import BodyText from "../../components/reusableComponents/BodyText";
import Logo from "../../assets/images/logo.PNG";
import { useDispatch } from "react-redux";
import AddGSTModal from "../../components/reusableComponents/AddGSTModal";
import { useSelector } from "react-redux";
import { useLocation, useHistory } from "react-router-dom";
import FlightSummaryForm from "../../form/FlightSummaryForm";
import Drawers from "../../components/Drawers";
import {
  agentlogogetDispatch,
  walletBalanceAgentDispatch,
} from "../../reducers/UserReducer";
import Login from "../../components/reusableComponents/Login";
import SelectedOnwardEtravRow from "../../components/reusableComponents/SelectedOnwardEtravRow";
import SelectedReturnEtravRow from "../../components/reusableComponents/SelectedReturnEtravRow";
import SelectedOnwardTboRow from "../../components/reusableComponents/SelectedOnwardTboRow";
import HeaderSection from "../../components/reusableComponents/HeaderSection";
import SessionExpireModal from "../../components/reusableComponents/SessionExpireModal";
import Footer from "./Footer";
import SelectedOnwardTJKRow from "../../components/reusableComponents/SelectedOnwardTJKRow";
import {
  setBaggage,
  setBaggageChild,
  setMealInfo,
  setMealInfoChild,
} from "../../reducers/UiReducer";
const useStyles = makeStyles(() => ({
	item: {
	  //   backgroundColor: "#ee8622",
	  display: "flex",
	  listStyle: "none",
	  marginBottom: 0,
	  marginTop: 0,
	  "&:hover": {
		backgroundColor: "#ee8622",
	  },
	},
	li: {
	  color: "white",
	  padding: "4px 8px",
	  background: "no-repeat",
	  borderRight: "none",
	},
	card: {
	  // padding: 10,
	  "&:hover": {
		// backgroundColor: "#ee8622",
		boxShadow: "rgb(149 157 165 / 20%) 0px 8px 24px",
	  },
	},
  }));
const SummaryFlight = () => {
  const [value, setValue] = React.useState("");
  const classes = useStyles();
  const { agentlogin } = useSelector((state) => state.user);
  const { baggageInfo, mealInfo, baggageInfoChild, mealInfoChild } =
    useSelector((state) => state.ui);
  const theme = useTheme();
  const location = useLocation();
  const [header, SetHeader] = React.useState("onlineRecharge");
  console.log("first", location);
  const matches = useMediaQuery(theme.breakpoints.down("xs"));
  const dispatch = useDispatch();
  const history = useHistory();
  const handelHeader = (val) => {
    SetHeader(val);
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  function timeConvert(n) {
    var num = n;
    var hours = num / 60;
    var rhours = Math.floor(hours);
    var minutes = (hours - rhours) * 60;
    var rminutes = Math.round(minutes);
    return rhours + " hr and " + rminutes + " min.";
  }
  function convertH2M(timeInHour) {
    console.log(timeInHour);
    var timeParts = timeInHour.split(":");
    return Number(timeParts[0]) * 60 + Number(timeParts[1]);
  }
  useEffect(() => {
    if (agentlogin && agentlogin.status === 200) {
      let logodata = {
        agent_id: agentlogin && agentlogin.result.result.id,
      };
      dispatch(agentlogogetDispatch(logodata));
      dispatch(
        walletBalanceAgentDispatch(
          agentlogin && agentlogin.result.result.email,
          agentlogin && agentlogin.result.result.id
        )
      );
    }
    dispatch(setMealInfo(null));
    dispatch(setMealInfoChild(null));
    dispatch(setBaggage(null));
    dispatch(setBaggageChild(null));
    // dispatch(setMealInfo(null));
    // dispatch(setMealInfoChild(null));
    // dispatch(setBaggage(null));
    // dispatch(setBaggageChild(null));
  }, []);

  return (
    <>
     <HeaderSection/>

      <Box style={{ background: "white", paddingLeft: 80, paddingRight: 80 }}>
        <Grid container spacing={2}>
          <Grid item xs={12} lg={8}>
            <Box display="flex" justifyContent="space-between" mt={"30px"}>
              {/* <Box>
                <TitleText
                  four
                  textStyle={{
                    fontFamily: "Josefin Sans, sans-serif",
                    fontWeight: 500,
                    fontSize: 22,
                  }}
                >
                  Review Your Booking
                </TitleText>
              </Box> */}
            </Box>

            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
            >
              <TitleText
                textStyle={{
                  fontFamily: "unset",
                  fontWeight: 500,
                  fontSize: 20,
                }}
              >
                Flight Details
              </TitleText>
              <span
                style={{ cursor: "pointer", color: "blue" }}
                onClick={() =>
                  history.push({
                    pathname: `/oneway/${location.state.body.Segments[0].Origin}/${location.state.body.Segments[0].Destination}/${location.state.body.Segments[0].PreferredDepartureTime}`,
                    state: {
                      body: location.state.body,
                    },
                  })
                }
              >
                <u>Choose Another Fare</u>
              </span>
            </Box>
			<Box
              style={{
                display: "flex",
                justifyContent: "space-between",
                padding: 15,
                border: "1px solid #dbdbdb",
                marginTop: 20,
                alignItems: "center",
              }}
              className={classes.card}
            >
              <Box>
                <img
                  src={`https://nitish.musafirbazar.com/static/media/${"SG"}.gif`}
                  width="50px"
                  height="50px"
                ></img>
                <span style={{ marginLeft: 10 }}>SpiceJet SG 328</span>
              </Box>
              <Box style={{ textAlign: "center" }}>
                <span style={{ fontSize: 18 }}>IXB</span>
                <p style={{ fontSize: 25 }}>15:55</p>
              </Box>
              <Box style={{ textAlign: "center" }}>
                <span style={{ color: "#ee8622" }}>2 hrs 50 mins</span>
                <p style={{ color: "#ee8622" }}>Direct</p>
              </Box>
              <Box style={{ textAlign: "center" }}>
                <span style={{ fontSize: 18 }}>BLR</span>
                <p style={{ fontSize: 25 }}>15:55</p>
              </Box>
              <Box style={{ textAlign: "center" }} onClick={()=>history.push('/summaryflight')}>
                {/* <span
                  style={{
                    background: "#ee8622",
                    color: "white",
                    fontWeight: "bold",
                    padding: "10px",
                  }}
                >
                  BOOK
                </span> */}
                {/* <p style={{ marginTop: 10 }}>Seat Left: 8</p> */}
              </Box>
            </Box>
            <FlightSummaryForm />
          </Grid>
          <Grid item xs={12} lg={4}>
            <Box style={{ position: "sticky", top: 84 }}>
              <Box
                style={{
                  background: "white",
                  padding: "10px 15px",
                  border: "1px solid #e6e6e6",
                  marginTop: "62px",
                  boxShadow: "0 0.5rem 1rem rgb(0 0 0 / 15%)",
                  borderRadius: "5px",
                  // position: 'sticky',
                  // top: 84,
                  zIndex: 1,
                }}
              >
                <Grid container alignItems="center">
                  <Grid item xs={4}>
                    Fare Details
                  </Grid>
                  <Grid item xs={8}>
                    <Divider style={{ background: "black" }} />
                  </Grid>
                </Grid>
                <Box
                  style={{
                    background: "rgb(166 185 255 / 17%)",
                    padding: "5px 10px",
                    margin: "10px 0 0",
                    borderRadius: "15px",
                  }}
                >
                  <BodyText textStyle={{ fontSize: 13 }}>
                    AMOUNT TO BE PAID
                  </BodyText>

                  <span>(inclusive of all taxes.)</span>
                </Box>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  mt={"10px"}
                ></Box>
                {baggageInfo?.length > 0 && (
                  <Box display="flex" justifyContent="space-between">
                    <BodyText textStyle={{ fontSize: 13 }}>
                      {`Excess Baggage ${
                        Number(
                          baggageInfo &&
                            baggageInfo?.length > 0 &&
                            baggageInfo
                              .map((item) => parseInt(item.split("|")[1]))
                              .reduce((prev, next) => prev + next)
                        ) +
                        Number(
                          baggageInfoChild &&
                            baggageInfoChild?.length > 0 &&
                            baggageInfoChild
                              .map((item) => parseInt(item.split("|")[1]))
                              .reduce((prev, next) => prev + next)
                        )
                      } Kg`}
                    </BodyText>
                    <TitleText textStyle={{ fontSize: 13 }}>
                      {`₹ ${
                        Number(
                          baggageInfo &&
                            baggageInfo?.length > 0 &&
                            baggageInfo
                              .map((item) => parseInt(item.split("|")[2]))
                              .reduce((prev, next) => prev + next)
                        ) +
                        Number(
                          baggageInfoChild &&
                            baggageInfoChild?.length > 0 &&
                            baggageInfoChild
                              .map((item) => parseInt(item.split("|")[2]))
                              .reduce((prev, next) => prev + next)
                        )
                      }`}
                    </TitleText>
                  </Box>
                )}
                {mealInfo?.length > 0 && (
                  <Box display="flex" justifyContent="space-between">
                    <BodyText textStyle={{ fontSize: 13 }}>
                      {`Meal (${
                        Number(mealInfo?.length) + Number(mealInfoChild?.length)
                      } Platter )`}
                    </BodyText>
                    <TitleText textStyle={{ fontSize: 13 }}>
                      {`₹ ${
                        Number(
                          mealInfo &&
                            mealInfo?.length > 0 &&
                            mealInfo
                              .map((item) => parseInt(item.split("|")[2]))
                              .reduce((prev, next) => prev + next)
                        ) +
                        Number(
                          mealInfoChild &&
                            mealInfoChild?.length > 0 &&
                            mealInfoChild
                              .map((item) => parseInt(item.split("|")[2]))
                              .reduce((prev, next) => prev + next)
                        )
                      }`}
                    </TitleText>
                  </Box>
                )}
                <Box display="flex" justifyContent="space-between">
                  <BodyText textStyle={{ fontSize: 13 }}>Total Taxes</BodyText>
                </Box>
                <Divider />
                {value ? (
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    mt={"5px"}
                    mb={"5px"}
                  >
                    <BodyText>Convenience Fees</BodyText>
                    <TitleText two>Rs 200</TitleText>
                  </Box>
                ) : (
                  ""
                )}

                <Divider />
              </Box>
            </Box>
          </Grid>
        </Grid>
        {/* </Container> */}
      </Box>
      <Footer />
      <AddGSTModal />
      <Drawers />
      {/* <SessionExpireModal /> */}
      <Login />
    </>
  );
};

export default SummaryFlight;
